import page2 from "./page2.pdf";
import page3 from "./page3.pdf";

export const secondPagePDF = {
    page2,
    page3,
}